<template>
  <v-container class="pa-0" v-if="product">
    <div class="pa-0" :class="getThemeColor">
    <v-row class="image-container ma-0">
      <div class="gallery" id="product-carousel">
        <VueSlickCarousel v-bind="cc" style="position:absolute;top:0;bottom:0;left:0;right:0;">
          <div
            v-for="photo in product.slider"
            :key="photo.id"
            style="position:absolute;top:0;bottom:0;left:0;right:0;"
          >
            <v-img
              height="100%"
              :src="ip+photo.url"
            />
          </div>
        </VueSlickCarousel>
      </div>
    </v-row>
    <v-row class="ma-0" v-animate-onscroll="'starter'" :class="$vuetify.breakpoint.xs?'flex-column':''">
      <v-col
        lg="6"
        xl="6"
        sm="6"
        :class="getThemeColor"
        style="display:flex;justify-content:center;align-items:center;"
        v-if="!$vuetify.breakpoint.xs"
      >
        <div class="pa-4" style="max-width:90%;">
          <div style="position:relative;">
            <div data-aos-anchor=".title-border" class="d-flex title-border" data-aos="custom-fade" data-aos-duration="2000" :class="[getThemeFontColor,{'border-green': product.theme=='white'},{'border-white': product.theme=='green'}]" style='margin-left:-5%;min-width:110%;padding:1px;'></div>
            <div :class="[$i18n.locale=='en'?'georgia':'NotoSerifTC' ,getThemeFontColor,{'bordertitle-white': product.theme=='white'},{'bordertitle-green': product.theme=='green'}]" style="opacity: 0;cursor:default" v-html="$t('product_info_page.title',{product_category: product.type[$i18n.locale]})"></div>
            <div data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="1000" data-aos-delay="1000" :class="[$i18n.locale=='en'?'georgia':'NotoSerifTC' ,getThemeFontColor,{'bordertitle-white': product.theme=='white'},{'bordertitle-green': product.theme=='green'}]" v-html="$t('product_info_page.title',{product_category: product.type[$i18n.locale]})"></div>
            <div data-aos-anchor=".title-border" class="d-flex title-border" data-aos="custom-fade" data-aos-duration="2000" :class="[getThemeFontColor,{'border-green': product.theme=='white'},{'border-white': product.theme=='green'}]" style='margin-left:-5%;min-width:110%;padding:1px;'></div>
          </div>
        </div>
      </v-col>
      <div v-if="$vuetify.breakpoint.xs" style="margin:auto;width:100%;max-width: 200px;margin-top:20px;margin-bottom:20px;">
        <div style="position:relative;margin:auto;" >
          <div data-aos-anchor=".title-border" class="d-flex title-border" data-aos="custom-fade" data-aos-duration="2000" :class="[getThemeFontColor,{'border-green': product.theme=='white'},{'border-white': product.theme=='green'}]" style='margin-left:-5%;min-width:110%;padding:1px;'></div>
          <div :class="[$i18n.locale=='en'?'georgia':'NotoSerifTC' ,getThemeFontColor,{'bordertitle-white': product.theme=='white'},{'bordertitle-green': product.theme=='green'}]" style="opacity: 0;cursor:default" v-html="$t('product_info_page.title',{product_category: product.type[$i18n.locale]})"></div>
          <div data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="1000" data-aos-delay="1000" :class="[$i18n.locale=='en'?'georgia':'NotoSerifTC' ,getThemeFontColor,{'bordertitle-white': product.theme=='white'},{'bordertitle-green': product.theme=='green'}]" v-html="$t('product_info_page.title',{product_category: product.type[$i18n.locale]})"></div>
          <div data-aos-anchor=".title-border" class="d-flex title-border" data-aos="custom-fade" data-aos-duration="2000" :class="[getThemeFontColor,{'border-green': product.theme=='white'},{'border-white': product.theme=='green'}]" style='margin-left:-5%;min-width:110%;padding:1px;'></div>
        </div>
      </div>
      <v-col
        lg="6"
        xl="6"
        sm="6"
        :class="$vuetify.breakpoint.xs?'pa-0':'pa-8'"
      >
        <div class="d-flex flex-wrap pa-0" :class="[getThemeColor, $vuetify.breakpoint.xs?'flex-column':'']" style="text-align: start;" v-for="(group, i) in product.ProductGroup" :key="group.id">
          <div class="d-flex" data-aos="custom-fade" :class="getThemeBorder" data-aos-duration="2000" v-if="i && !$vuetify.breakpoint.xs" style='min-width:100%;padding:1px; margin-top:10px; margin-bottom:20px;'></div>
          <div class="d-flex" data-aos="custom-fade" :class="getThemeBorder" data-aos-duration="2000" v-if="i && $vuetify.breakpoint.xs" style='margin:auto;width:50%;padding:1px; margin-top:10px; margin-bottom:20px;'></div>
          <v-col
            lg="12"
            xl="12"
            sm="12"
            class="pa-0 product-title" :class="[getThemeFontColor,$i18n.locale=='en'?'DinCond':'NotoSerifTC', $vuetify.breakpoint.xs?'text-center':'']"
            data-aos="custom-fade" data-aos-duration="3000" 
          >
            {{group.title[$i18n.locale]}}
          </v-col>
          <v-col
            v-for="p in group.product_unit"
            :key="p.id"
            :class="[getThemeFontColor,$i18n.locale=='en'?'DinCond':'MHeiHK', $vuetify.breakpoint.xs?'text-center':'']"
            outlined
            tile
            lg="4"
            xl="4"
            sm="6"
            class="product-item pa-0"
            data-aos="custom-fade" data-aos-duration="3000"
          >
            {{p.name[$i18n.locale]}}
          </v-col>
        </div>
      </v-col>
      <v-row class="ma-0" :class="getThemeColor" style="position:relative;">
        <div class="button" style="float:left;" v-on:click="goBack()">
          <simple-line-icons
            icon="arrow-left"
            size="small"
            color="mediumseagreen"
            no-svg
          />
          <span style="padding-left:10px">{{ $t('product_info_page.back')}}</span>
        </div>
        <div class="button" style="float:left;margin-left: auto;" v-on:click="goNext()"><span style="padding-right:10px">{{ $t('product_info_page.next')}}</span><simple-line-icons
          icon="arrow-right"
          size="small"
          color="mediumseagreen"
          no-svg
        /></div>
      </v-row>
    </v-row>
    </div>
  </v-container>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import axios from 'axios';
var ip = "https://lorencegroup.com/api";
export default {
  name: 'ProductInfo',
  components: {
    VueSlickCarousel
  },
  data: function () {
    return {
      "cc": {
        "arrows": false,
        "dots": true,
        "fade": true,
        "infinite": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,

        "autoplay": true,
        "autoplaySpeed":3000,
        "speed": 1000,
        "pauseOnDotsHover": true,
        "pauseOnFocus": true,
        "pauseOnHover": true,
      },
      product: null,
      ip: ip
    }
  },
  methods: {
    goBack(){
      let newid = this.product.id - 1;
      if(newid == 0){
        newid = 9;
      }
      this.$router.replace({ name: 'Product Info', params: { pid: newid } })
      location.reload()
    },
    goNext(){
      let newid = this.product.id + 1;
      if(newid == 10){
        newid = 1;
      }
      this.$router.replace({ name: 'Product Info', params: { pid: newid } })
      location.reload()
    },
  },
  created() {
    console.log('route', this.$router.history.current.params.pid);
  },
  mounted () {
    axios.get(ip+"/products/"+this.$router.history.current.params.pid)
    .then(response => {
      this.product = response.data;
      this.product.type=[]
      this.product.type["en"] = this.product.display_name_english;
      this.product.type["zh_TW"] = this.product.display_name_trad_chinese;
      this.product.ProductGroup.forEach(pg => {
        
        console.log("pg", pg)
        pg.title = [];
        pg.title["en"] = pg.display_title_english;
        pg.title["zh_TW"] = pg.display_title_trad_chinese;
        pg.product_unit.forEach(p => {
          p.name=[];
          p.name["en"] = p.product_name_english;
          p.name["zh_TW"] = p.product_name_trad_chinese;
        })
      });
      console.log(this.product)
      // this.products.forEach(product => {
      //   product["en"] = {
      //     type: product.display_name_english
      //   }
      //   product["zh_TW"] = {name: product.display_name_traditional_chinese}
      // });
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  computed: {
    getThemeColor: function(){
      return {
        'white-theme': this.product.theme=='white',
        'green-theme': this.product.theme=='green'
      }
    },
    getThemeFontColor: function(){
      return {
        'white-theme-font': this.product.theme=='white',
        'green-theme-font': this.product.theme=='green'
      }
    },
    getThemeBorder: function(){
      return {
        'green-border': this.product.theme=='white',
        'white-border': this.product.theme=='green'
      }
    }
  }
}
</script>

<style scoped>
.gallery{
  position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
}
.image-container{
  position: relative;
  padding:0px;
  padding-top: 50%;
}
.image{
  position: absolute;
  top:0;
  bottom: 0;
  left:0;
  right:0;
}
.name{
  margin:auto;
  color: white;
  font-size: 3em;
  padding: 5px;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
}
.item{
  color: white;
}

.greenitem{
  color: #19442A;
}
.button{
  margin: 30px;
  padding: 5px 10px;
  color:mediumseagreen;
  border: mediumseagreen solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer;
}

.bordertitle-green{
  text-transform: uppercase;
  letter-spacing: 5px;
  font-size: 30px;
  margin:auto;
  padding: 15px;
  margin-top:16px;
  margin-bottom:16px;
}

.mobile .bordertitle-green{
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 20px;
  margin:auto;
  padding: 10px;
  margin-top:0px;
  margin-bottom:0px;
}

.bordertitle-white{
  text-transform: uppercase;
  letter-spacing: 5px;
  font-size: 30px;
  margin:auto;
  padding: 15px;
  margin-top:16px;
  margin-bottom:16px;
}

.mobile .bordertitle-white{
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 20px;
  margin:auto;
  padding: 10px;
  margin-top:0px;
  margin-bottom:0px;
}

.green-border{
  border-top:1px solid #19442A;
}

.white-border{
  border-top:1px solid white;
}

@media (min-width: 768px){
  .product-title{
    font-size: 16px;
    cursor:default;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .product-item{
    font-size:14px;
    padding:0 0 5px 0 !important;
    margin-top:5px;
  }
}


@media (min-width: 992px){
  .product-title{
    font-size: 16px;
    cursor:default;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .product-item{
    font-size:14px;
    padding:0 0 5px 0 !important;
    margin-top:5px;
  }
}

@media (min-width: 1264px){
  .product-title{
    font-size: 18px;
    cursor:default;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .product-item{
    font-size:18px;
    padding:0 0 5px 0 !important;
    margin-top:5px;
  }
}  

@media (min-width: 1904px){
  .product-title{
    font-size: 20px;
    cursor:default;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .product-item{
    font-size:18px;
    padding:0 0 5px 0 !important;
    margin-top:5px;
  }
}  
</style>

